import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOldPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M6 1V3H20V17C20 19.7614 17.7614 22 15 22H9C6.23858 22 4 19.7614 4 17V1H6ZM8 7H16V14H8V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldPhone;
